import { createContext, useContext } from 'react';
import { useWorkspace } from './context';

/**
 * Where an editor lives: in the docked canvas (the default) or in the view
 * itself (Knowledge's full page). Each keeps its own unsaved-edit flag, so a
 * move asks only about the editor it unmounts, and Discard never marks an
 * editor clean that stays on screen.
 */
export type EditOwner = 'canvas' | 'view';

export const EditOwnerContext = createContext<EditOwner>('canvas');

/** Report this editor's unsaved edits to its owner's flag. */
export function useReportUnsavedEdits(): (dirty: boolean) => void {
  const ws = useWorkspace();
  return useContext(EditOwnerContext) === 'view' ? ws.setViewDirty : ws.setCanvasDirty;
}
